import { useRecoilState, useResetRecoilState } from "recoil";
import { AllstarOauthState } from "../../State/oauth";
import { useEffect } from "react";

export const useOauthStateAndCleanup = () => {
  const [allstarOauthState, setAllstarOauthState] =
    useRecoilState(AllstarOauthState);

  const resetAllstarOauthState = useResetRecoilState(AllstarOauthState);

  useEffect(() => {
    return () => {
      resetAllstarOauthState();
    };
  }, [allstarOauthState, setAllstarOauthState, resetAllstarOauthState]);

  return {
    successMessage: allstarOauthState.successMessage,
    errorMessage: allstarOauthState.errorMessage,
    errorType: allstarOauthState.errorType,
    resetAllstarOauthState,
  };
};
